module.exports = __webpack_public_path__ + "static/img/hua10.f33ade5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hua10.png
// module id = DKMP
// module chunks = 1